module.exports = __webpack_public_path__ + "img/Happiness_Rate_24.78209a8a.png";